import { BuildingTheme } from './types';
import { FailureActionPayload } from 'store/errors/types';
import { createAsyncAction } from 'typesafe-actions';

export const getBuildingTheme = createAsyncAction(
  'GET_BUILDING_THEME_REQUEST',
  'GET_BUILDING_THEME_SUCCESS',
  'GET_BUILDING_THEME_FAILURE',
)<string, BuildingTheme, FailureActionPayload>();
